"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Jellyfin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api/activity-log-api"), exports);
__exportStar(require("./api/api-key-api"), exports);
__exportStar(require("./api/artists-api"), exports);
__exportStar(require("./api/audio-api"), exports);
__exportStar(require("./api/branding-api"), exports);
__exportStar(require("./api/channels-api"), exports);
__exportStar(require("./api/collection-api"), exports);
__exportStar(require("./api/configuration-api"), exports);
__exportStar(require("./api/dashboard-api"), exports);
__exportStar(require("./api/devices-api"), exports);
__exportStar(require("./api/display-preferences-api"), exports);
__exportStar(require("./api/dlna-api"), exports);
__exportStar(require("./api/dlna-server-api"), exports);
__exportStar(require("./api/dynamic-hls-api"), exports);
__exportStar(require("./api/environment-api"), exports);
__exportStar(require("./api/filter-api"), exports);
__exportStar(require("./api/genres-api"), exports);
__exportStar(require("./api/hls-segment-api"), exports);
__exportStar(require("./api/image-api"), exports);
__exportStar(require("./api/image-by-name-api"), exports);
__exportStar(require("./api/instant-mix-api"), exports);
__exportStar(require("./api/item-lookup-api"), exports);
__exportStar(require("./api/item-refresh-api"), exports);
__exportStar(require("./api/item-update-api"), exports);
__exportStar(require("./api/items-api"), exports);
__exportStar(require("./api/library-api"), exports);
__exportStar(require("./api/library-structure-api"), exports);
__exportStar(require("./api/live-tv-api"), exports);
__exportStar(require("./api/localization-api"), exports);
__exportStar(require("./api/media-info-api"), exports);
__exportStar(require("./api/movies-api"), exports);
__exportStar(require("./api/music-genres-api"), exports);
__exportStar(require("./api/notifications-api"), exports);
__exportStar(require("./api/package-api"), exports);
__exportStar(require("./api/persons-api"), exports);
__exportStar(require("./api/playlists-api"), exports);
__exportStar(require("./api/playstate-api"), exports);
__exportStar(require("./api/plugins-api"), exports);
__exportStar(require("./api/quick-connect-api"), exports);
__exportStar(require("./api/remote-image-api"), exports);
__exportStar(require("./api/scheduled-tasks-api"), exports);
__exportStar(require("./api/search-api"), exports);
__exportStar(require("./api/session-api"), exports);
__exportStar(require("./api/startup-api"), exports);
__exportStar(require("./api/studios-api"), exports);
__exportStar(require("./api/subtitle-api"), exports);
__exportStar(require("./api/suggestions-api"), exports);
__exportStar(require("./api/sync-play-api"), exports);
__exportStar(require("./api/system-api"), exports);
__exportStar(require("./api/time-sync-api"), exports);
__exportStar(require("./api/trailers-api"), exports);
__exportStar(require("./api/tv-shows-api"), exports);
__exportStar(require("./api/universal-audio-api"), exports);
__exportStar(require("./api/user-api"), exports);
__exportStar(require("./api/user-library-api"), exports);
__exportStar(require("./api/user-views-api"), exports);
__exportStar(require("./api/video-attachments-api"), exports);
__exportStar(require("./api/video-hls-api"), exports);
__exportStar(require("./api/videos-api"), exports);
__exportStar(require("./api/years-api"), exports);
